import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { ConfirmButton } from 'components/common';

const GroupUsersRemove = connect(state => state)(class extends Component {
  removeUser = async () => {
    const { pageState: { group }, updateUsers, userId } = this.props;

    await api.delete(`/admin/groups/${group.id}/users?UserId=${userId}`);
    await updateUsers({});
    return true;
  }

  render() {
    const { messages } = this.props;

    return (
      <ConfirmButton
        actionText={messages.commonRemove}
        buttonIcon="trash-alt"
        buttonText={messages.commonRemoveUser}
        category="danger"
        confirmText={messages.groupsUsersRemoveConfirm}
        confirmTitle={messages.commonRemoveUser}
        onConfirm={this.removeUser}
        successMessage={messages.commonRemoveUserSuccess}
      />
    );
  }
});

export default GroupUsersRemove;
